import { t } from "../../i18n";
import { Boxes } from "lucide-react";
import type { PreviewAsset } from "./GameAssetPreview.types";
import { assetKind } from "./GameAssetPreview.types";
import { ModelPreview } from "../models/ModelPreview";
import { SheetPreview } from "./SheetPreview";

export function GameAssetPreview({ asset }: { asset: PreviewAsset }) {
  const kind = assetKind(asset);
  if (kind === "sprite" || kind === "tileset")
    return <SheetPreview asset={asset} kind={kind} />;
  if (kind === "model3d") {
    return (
      <div className="space-y-2">
        <ModelPreview asset={asset} />
        <div className="flex items-center gap-2 text-xs text-stone-500 dark:text-stone-400">
          <Boxes size={14} />
          <span>
            {t("{{mimeType}} · drag to orbit, scroll to zoom", {
              mimeType: asset.mimeType,
            })}
          </span>
        </div>
      </div>
    );
  }
  if (asset.mimeType.startsWith("image/")) {
    return (
      <img
        src={asset.url}
        alt={asset.name}
        className="max-h-80 w-full rounded-xl object-contain"
      />
    );
  }
  return null;
}
